import { SafeHtml } from '@angular/platform-browser';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements OnInit {

  public htmlContent: SafeHtml;
  public isVisible = false;

  @Input() top: string;
  @Input() left: string;
  @Input() position = 'absolute';
  @Input() display = 'none';
  @Input() set content(value: SafeHtml) {
    this.htmlContent = value;
    this.isVisible = this.htmlContent !== null && this.htmlContent !== undefined;
  };

  constructor() { }

  ngOnInit(): void {

  }

  ocultar() {
    this.isVisible = false;
  }

}
